import api, {
  buildActivityScopeHeaders,
  buildCompanyScopeHeaders,
} from "./api";


function buildStudioLayoutVersionScopeHeaders({
  companyUuid,
  activityUuid,
} = {}) {
  return {
    ...buildCompanyScopeHeaders(
      companyUuid
    ),

    ...buildActivityScopeHeaders(
      activityUuid
    ),
  };
}


export const fetchStudioLayoutVersion = (
  versionId,
  {
    companyUuid,
    activityUuid,
  } = {}
) =>
  api.get(
    `/restaurant/studio/versions/${encodeURIComponent(versionId)}`,
    {
      headers:
        buildStudioLayoutVersionScopeHeaders({
          companyUuid,
          activityUuid,
        }),
    }
  );


export default Object.freeze({
  fetchStudioLayoutVersion,
});
